// Organization Data Table Configuration - matching admin-web structure
import React, { useMemo } from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { IColumnConfig } from '@/types/admin/dataTable';
import { IOrganizationRowData } from '@/types/admin/organizations';
import { formatTaskDate } from '@/utils/admin/date';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';

const useColumnStyles = () =>
  useThemedStyles(({ components }) =>
    StyleSheet.create({
      nameText: {
        fontWeight: '700',
        fontSize: 14,
        color: components.admin.dataCell.text,
      },
      cellText: {
        fontSize: 14,
        color: components.admin.dataCell.text,
      },
    }),
  );

const NameCell: React.FC<{ value: string }> = ({ value }) => {
  const styles = useColumnStyles();
  return (
    <View>
      <Text style={styles.nameText}>{value}</Text>
    </View>
  );
};

const TextCell: React.FC<{ value: string }> = ({ value }) => {
  const styles = useColumnStyles();
  return (
    <View>
      <Text style={styles.cellText}>{value}</Text>
    </View>
  );
};

const DateCell: React.FC<{ value: string }> = ({ value }) => {
  const styles = useColumnStyles();
  return (
    <View>
      <Text style={styles.cellText}>{value ? formatTaskDate(value) : 'N/A'}</Text>
    </View>
  );
};

export function useOrganizationTableColumns(): IColumnConfig<IOrganizationRowData>[] {
  return useMemo<IColumnConfig<IOrganizationRowData>[]>(
    () => [
      {
        key: 'name',
        label: 'NAME',
        sortable: true,
        sortType: 'string',
        filterable: true,
        filterType: 'text',
        width: 200,
        visible: true,
        renderCell: (value: string) => <NameCell value={value} />,
      },
      {
        key: 'domain',
        label: 'DOMAIN',
        sortable: true,
        sortType: 'string',
        filterable: true,
        filterType: 'text',
        width: 200,
        visible: true,
        renderCell: (value: string) => <TextCell value={value} />,
      },
      {
        key: 'createdAt',
        label: 'CREATED AT',
        sortable: true,
        sortType: 'date',
        filterable: true,
        filterType: 'date',
        width: 150,
        visible: true,
        renderCell: (value: string) => <DateCell value={value} />,
      },
    ],
    [],
  );
}
